import { ActionIcon } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { Panel } from 'components/Panel';
import { tKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';

import type { Automation } from '../../../api';
import { useEditAutomation } from '../../AutomationWizard';

import { ConditionRow } from './ConditionRow';

type ConditionsPanelProps = {
  automation: Automation;
  isLoading: boolean;
};

export const ConditionsPanel = ({ automation, isLoading }: ConditionsPanelProps) => {
  const { t } = useTranslation();

  const onClickEdit = useEditAutomation();

  return (
    <Panel
      isLoading={isLoading}
      title={t(tKeys.AUTOMATION.WIZARD.STEPS.CONDITIONS)}
      topRight={
        <ActionIcon onClick={() => onClickEdit(automation.id, 2)} variant="default">
          <IconPencil stroke={1.5} size={18} />
        </ActionIcon>
      }
    >
      {automation.conditions.map((condition, index) => (
        <ConditionRow key={index} condition={condition} model={automation.targetModel} />
      ))}
    </Panel>
  );
};
